import { render, staticRenderFns } from "./WholesaleBillDeleted.vue?vue&type=template&id=d959d2f2&scoped=true"
import script from "./WholesaleBillDeleted.vue?vue&type=script&lang=js"
export * from "./WholesaleBillDeleted.vue?vue&type=script&lang=js"
import style0 from "./WholesaleBillDeleted.vue?vue&type=style&index=0&id=d959d2f2&prod&scoped=true&lang=css"
import style1 from "./WholesaleBillDeleted.vue?vue&type=style&index=1&id=d959d2f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d959d2f2",
  null
  
)

export default component.exports